import { render, staticRenderFns } from "./FAQWalk.vue?vue&type=template&id=c21fc8be&scoped=true"
import script from "./FAQWalk.vue?vue&type=script&lang=js"
export * from "./FAQWalk.vue?vue&type=script&lang=js"
import style0 from "./FAQWalk.vue?vue&type=style&index=0&id=c21fc8be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21fc8be",
  null
  
)

export default component.exports